<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'App',
  created () {
    this._init_sensors()
  },
  computed: {
    ...mapState([ 'userInfo' ])
  },
  methods: {
    // 初始化神策
    _init_sensors () {
      // 神策埋点-静态公共属性设置
      this.$sensors.registerPage({
        guid: this.$route.query.appType ? 'xunmengtu-blind-box':'blind-box',
        platform_type: 'H5',
        channel: this.$store.state.channel || '',
        page_version: require('../config/prod.env').VERSION || '',
        phone_number: this.userInfo.phoneNumber || '',
        page_name: 'Gift_raffle_template',
        app_activity_id: this.$route.query.app_activity_id || 'unkown'
      })

      if (this.userInfo.userId) {
        this.$sensors.login('android_' + this.userInfo.userId, function () {
        // 回调函数的使用需要 SDK 版本大于等于 1.14.8
        })
      }
    }
  }
}
</script>

<style>
 #app {
  width: 100vw;
  height: 100vh;
  position: relative;
 }
</style>
